<script>
import * as echarts from 'echarts'

export default {
  name: 'productViewTotalView',
  data() {
    return {
      loading: false,
      productName: '',
      list: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      chart: null,
      resizeHandler: null,
    }
  },
  computed: {
    xNames() {
      return (this.list || []).map(i => i.productName)
    },
    yViews() {
      return (this.list || []).map(i => this.toNumber(i.totalViews))
    },
    totalAll() {
      return (this.list || []).reduce((sum, i) => sum + this.toNumber(i.totalViews), 0)
    }
  },
  mounted() {
    this.getData()
    this.resizeHandler = () => {
      if (this.chart) this.chart.resize()
    }
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
      this.searchTimer = null
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    search() {
      this.currentPage = 1
      this.getData()
    },
    toNumber(v) {
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },
    getData() {
      this.loading = true
      this.$axios.get("/hadoop/productViewTotal", {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          productName: this.productName
        }
      }).then((res) => {
        this.total = res.data.data.total
        this.list = res.data.data.records
        this.loading = false
        this.$nextTick(() => this.renderChart())
      }).catch(() => {
        this.loading = false
      })
    },
    renderChart() {
      const el = this.$refs.chart
      if (!el) return

      if (!this.chart) this.chart = echarts.init(el)

      const option = {
        title: {text: '商品累计查看次数', left: 'center'},
        tooltip: {trigger: 'axis', axisPointer: {type: 'shadow'}},
        grid: {left: 120, right: 30, top: 80, bottom: 30},
        xAxis: {type: 'value', name: '累计查看次数'},
        yAxis: {type: 'category', data: this.xNames, inverse: true},
        series: [{
          name: '累计查看次数',
          type: 'bar',
          data: this.yViews,
          itemStyle: {color: '#409EFF'},
          label: {show: true, position: 'right'}
        }]
      }

      this.chart.setOption(option, true)
    }
  }
}
</script>

<template>
  <div class="wrap">
    <div class="toolbar">
      <div class="title">商品累计查看次数</div>
      <div class="actions">
        <el-form :inline="true">
          <el-form-item>
            <el-input v-model="productName" placeholder="商品名" clearable style="width: 220px"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-main class="flex-container">
      <el-table
        :data="list"
        border
        stripe
        v-loading="loading"
        element-loading-text="加载中..."
        width="500"
      >
        <el-table-column type="index" label="" width="60"/>
        <el-table-column prop="productName" label="商品名称" width="250" show-overflow-tooltip/>
        <el-table-column prop="totalViews" label="累计查看次数" width="140"/>
      </el-table>

      <div class="chart" ref="chart"/>

    </el-main>

    <el-footer class="el-footer">
      <el-pagination
        id="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5,10, 20, 50, 100]"
        :page-size="pageSize"
        :pager-count="11"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-footer>
  </div>
</template>

<style scoped>
.wrap {
  padding: 16px;
}

.toolbar {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.title {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
  line-height: 32px;
}

.actions {
  display: flex;
  align-items: center;
  margin-left: 100px;
}

.mb16 {
  margin-bottom: 16px;
}

.mt16 {
  margin-top: 16px;
}

.card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 14px;
  min-height: 76px;
}

.card-title {
  font-size: 12px;
  color: #909399;
}

.card-value {
  margin-top: 6px;
  font-size: 22px;
  font-weight: 700;
  color: #303133;
}

.card-sub {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}

.chart {
  height: 1000px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  flex-shrink: 0;
  width: 800px;
}

.flex-container {
  display: flex; /* 开启弹性布局 */
  gap: 20px; /* 左右之间的间距，可自行调整 */
  align-items: flex-start; /* 顶部对齐 */
}
</style>



// WEBPACK FOOTER //
// src/views/productViewTotalView.vue